// @ vendors
const { APIGet } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');

const setMainDepositsIsFetching = () => ({
    type: actionTypes.SET_MAIN_DEPOSITS_REQUEST,
});

const setMainDepositsSuccess = response => ({
    type: actionTypes.SET_MAIN_DEPOSITS_SUCCESS,
    payload: {
        response
    }
});

const setMainDepositsFailure = () => ({
    type: actionTypes.SET_MAIN_DEPOSITS_FAILURE,
});

const getMainDeposits = (depositType,depositIdentifier = '') => (dispatch) => {
    dispatch(setMainDepositsIsFetching());
    const requestData = {
        depositType
    };

    return APIGet(dispatch, apiURLBuilder.getURL('activeDeposits',{depositIdentifier}), {query: requestData})
        .then(response => {
            dispatch(setMainDepositsSuccess(response));
        })
        .catch(response => {
            if (response.error) {
                dispatch(setMainDepositsFailure());
            } else {
                throw response;
            }
        });
};

module.exports = {
    getMainDeposits,
};
